import React from "react";
import Button from "../components/Button";
import PageTitle from "../components/PageTitle";

export default function Demo() {
  return (
    <>
      <PageTitle title="Demo" path={["Pages ", "Demo"]} />
      <div className="max-w-5xl mx-auto mt-8">
        <h2 className="text-xl font-bold font-fontOne ">Hekto Demo</h2>
        <p className=" text-sub_text_color text-sm">
          Cart/Information/Shipping/Payment
        </p>
      </div>
      <div className="flex justify-between max-w-5xl mx-auto font-fontOne mt-10">
        {/* col 1 */}
        <div className="w-8/12">
          <form className=" bg-[#F8F8FD] w-full py-10 px-5 text-sub_text_color">
            <div className="flex justify-between">
              <h3 className=" font-bold text-lg mb-4 text-text">
                Contact Information
              </h3>
              <div className=" text-sub_text_color">
                Already have an account?
                <a className="hover:underline" href="/">
                  Login
                </a>
              </div>
            </div>
            <div className=" my-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                className="block w-full bg-transparent focus:outline-none mx-2"
                type="text"
                placeholder="Email or Mobile Number"
              />
            </div>
            <label className=" block mb-14">
              <input type="checkbox" className=" accent-green mr-3" />
              Keep me up to date on news and exclusive offers
            </label>
            <h3 className=" font-bold text-lg mb-4 text-text">
              Contact Information
            </h3>
            {/* name row */}
            <div className=" my-3 flex">
              <div className=" w-1/2 mr-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
                <input
                  className=" bg-transparent focus:outline-none mx-2"
                  type="text"
                  placeholder="First Name (optional)"
                />
              </div>
              <div className=" w-1/2 ml-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
                <input
                  className=" bg-transparent focus:outline-none mx-2"
                  type="text"
                  placeholder="Second Name"
                />
              </div>
            </div>
            {/* address */}
            <div className=" my-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                className="block w-full bg-transparent focus:outline-none mx-2"
                type="text"
                placeholder="Address"
              />
            </div>
            {/* Apartment */}
            <div className=" my-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                className="block w-full bg-transparent focus:outline-none mx-2"
                type="text"
                placeholder="Apartment (optional)"
              />
            </div>
            {/* City */}
            <div className=" my-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                className="block w-full bg-transparent focus:outline-none mx-2"
                type="text"
                placeholder="City"
              />
            </div>
            {/* last row */}
            <div className=" my-3 flex">
              <div className=" w-1/2 mr-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
                <input
                  className=" bg-transparent focus:outline-none mx-2"
                  type="text"
                  placeholder="Iraq"
                />
              </div>
              <div className=" w-1/2 ml-3 mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
                <input
                  className=" bg-transparent focus:outline-none mx-2"
                  type="text"
                  placeholder="Zip code"
                />
              </div>
            </div>
            <Button color={"pink"}>Continue Shopping</Button>
          </form>
        </div>
        {/* col 2 */}
        <div className="w-4/12 p-4 font-fontTwo">
          <RightListItem img={require("../assets/demo/img01.png")} />
          <RightListItem img={require("../assets/demo/img02.png")} />
          <RightListItem img={require("../assets/demo/img03.png")} />
          <div></div>
        </div>
      </div>
    </>
  );
}

function RightListItem({ img }) {
  return (
    <div className=" pb-7 border-b mb-6">
      <div className="flex font-fontOne items-start mb">
        {/* image container */}
        <div className="w-20 h-20 mr-1">
          <img alt="" src={img} className=" object-cover" />
        </div>
        {/* text container */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold">Asdf koecm</h3>
          <div className=" text-sub_text_color text-sm">Color: Borwn</div>
          <div className=" text-sub_text_color text-sm">Size: XL</div>
        </div>
        {/* price col */}
        <div className=" self-center">$32.00</div>
      </div>
    </div>
  );
}
